import { AfterViewInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, Directive } from '@angular/core';
import { ClientConstantType } from '../client.constant';
import { ClientService } from '../client.service';

type ClientResolverLayoutType = 'main' | 'filter-drawer' | 'taiao-dashboard' | 'custom-widget';

@Directive()
export abstract class ClientResolverBase implements AfterViewInit {
  @ViewChild('layoutView', { read: ViewContainerRef }) layoutView!: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private clientService: ClientService) {}

  private async buildComponent() {
    const client: ClientConstantType = this.clientService.getClient();

    /**
     * Component loading is dynamic, so there be some dragons here to keep AOT happy
     */
    const componentName = `${client.toLowerCase()}_${this.getLayoutType()
      .split('-')
      .map((x: string) => x.substring(0, 1).toUpperCase() + x.substring(1).toLowerCase())
      .join('')}LayoutComponent`;
    const defaultComponentName = `default_${this.getLayoutType()
      .split('-')
      .map((x: string) => x.substring(0, 1).toUpperCase() + x.substring(1).toLowerCase())
      .join('')}LayoutComponent`;
    let componentStruct;
    let resolvedComponent;
    try {
      componentStruct = await import(
        `../clients/${client}/${this.getLayoutType()}-layout/${this.getLayoutType()}-layout.component`
      );
      resolvedComponent = this.componentFactoryResolver.resolveComponentFactory(componentStruct[componentName]);
    } catch (e) {
      componentStruct = await import(
        `../clients/default/${this.getLayoutType()}-layout/${this.getLayoutType()}-layout.component`
      );
      resolvedComponent = this.componentFactoryResolver.resolveComponentFactory(componentStruct[defaultComponentName]);
    }

    if (this.getLayoutType() === 'custom-widget') {
      // all kinds of mischief
      // this makes assumptions on the structure of where the
      // <app-resolver-custom-widget-layout> (i.e. it is placed inside of the dashboard div)
      // tag is placed and the structure of the
      // custom-widget-layout.component.html (i.e. is expects a non nested list of components to add to the dashboard)
      if (this.layoutView) {
        this.layoutView.clear(); // Clear existing content
        const componentRef = this.layoutView.createComponent(resolvedComponent);

        // Get the parent element and append the component's element
        const parentElement = this.layoutView.element.nativeElement.parentElement.parentElement;
        if (parentElement) {
          const children = Array.from(componentRef.location.nativeElement.children);
          children.forEach((child) => {
            parentElement.appendChild(child);
          });
        }
      }

      // remove the original widget container
      this.layoutView.element.nativeElement.parentElement.remove();
    } else {
      if (this.layoutView) {
        this.layoutView.clear();
        this.layoutView.createComponent(resolvedComponent);
      }
    }
  }

  protected abstract getLayoutType(): ClientResolverLayoutType;

  ngAfterViewInit(): void {
    this.buildComponent();
  }
}
